import { Pipe, PipeTransform } from '@angular/core';
import { GStatic } from '../../services/GStatic';
import * as moment from 'moment/moment';

@Pipe({
  name: 'dateStrTransform',
})
export class DateStrTransformPipe implements PipeTransform {
  transform(value: any, inputFormat: string = 'YYYY-MM-DD hh:mm:ss'): string {
    const formattedDate = moment(value, inputFormat).format('ll');

    if (formattedDate !== 'Invalid date') {
      return formattedDate;
    } else {
      return localStorage.getItem('lang') === 'ar' ? 'غير محدد' : 'N/A';
    }
  }
}
